// @flow
'use strict';

import * as React from 'react';

import type { ITotais } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';
import TableDetalhesComLinhas from '../../../common/detalhes_documento/table_detalhes_com_linhas';

type TotaisProps = {
  totais : ITotais,
};

export default function Totais({ totais } : TotaisProps) {
  const { icms, issqn, retencaoTributos, totalImpostoSeletivo, totalIbsCbs } = totais || {};
  const { totalIbs, totalCbs, totalMonofasia, totalEstornoCredito } = totalIbsCbs || {};

  return (
      <div className="tab-pane active">
        <h3>Totais Referentes ao ICMS</h3>
        <TableDetalhesComLinhas data={ icms }>
          <tr>
            <ColumnDetalhes field="bcIcms" type="moeda" width="25%">BC ICMS</ColumnDetalhes>
            <ColumnDetalhes field="icms" type="moeda" width="25%">ICMS</ColumnDetalhes>
            <ColumnDetalhes field="icmsDesonerado" type="moeda" width="25%">ICMS Desonerado</ColumnDetalhes>
            <ColumnDetalhes field="icmsFcpUFDest" type="moeda" width="25%">ICMS FCP UF Dest.</ColumnDetalhes>
          </tr>
          <tr>
            <ColumnDetalhes field="icmsInterestUFDest" type="moeda">ICMS Interest. UF Dest.</ColumnDetalhes>
            <ColumnDetalhes field="icmsInterestUFRemet" type="moeda">ICMS Interest. UF
              Remet.</ColumnDetalhes>
            <ColumnDetalhes field="fcp" type="moeda">FCP</ColumnDetalhes>
            <ColumnDetalhes field="bcIcmsSt" type="moeda">BC ICMS ST</ColumnDetalhes>
          </tr>
          <tr>
            <ColumnDetalhes field="icmsSt" type="moeda">ICMS ST</ColumnDetalhes>
            <ColumnDetalhes field="fcpRetidoSt" type="moeda">FCP retido ST</ColumnDetalhes>
            <ColumnDetalhes field="fcpRetidoAntSt" type="moeda">FCP retido ant. ST</ColumnDetalhes>
            <ColumnDetalhes field="valorProdServ" type="moeda">Valor Produtos e Serviços</ColumnDetalhes>
          </tr>
          <tr>
            <ColumnDetalhes field="frete" type="moeda">Frete</ColumnDetalhes>
            <ColumnDetalhes field="seguro" type="moeda">Seguro</ColumnDetalhes>
            <ColumnDetalhes field="desconto" type="moeda">Desconto</ColumnDetalhes>
            <ColumnDetalhes field="ii" type="moeda">II</ColumnDetalhes>
          </tr>
          <tr>
            <ColumnDetalhes field="ipi" type="moeda">IPI</ColumnDetalhes>
            <ColumnDetalhes field="ipiDevolvido" type="moeda">IPI Devolvido</ColumnDetalhes>
            <ColumnDetalhes field="pis" type="moeda">PIS</ColumnDetalhes>
            <ColumnDetalhes field="cofins" type="moeda">COFINS</ColumnDetalhes>
          </tr>
          <tr>
            <ColumnDetalhes field="outrasDespesas" type="moeda">Outras Despesas</ColumnDetalhes>
            <ColumnDetalhes field="totalNfe" type="moeda">Total da NF-e</ColumnDetalhes>
            <ColumnDetalhes field="totalAproxTributos" type="moeda" colSpan={ 2 }>Total Aprox. de
              Tributos</ColumnDetalhes>
          </tr>
        </TableDetalhesComLinhas>

        <h3>Total do Imposto Seletivo</h3>
        <RowDetalhes data={ totalImpostoSeletivo }>
          <ColumnDetalhes field="valorImpostoSeletivo" type="moeda">Total do Imposto Seletivo</ColumnDetalhes>
        </RowDetalhes>

        <h3>Totais da NFe com IBS e CBS</h3>
        <RowDetalhes data={ totalIbsCbs }>
          <ColumnDetalhes field="bcIbsCbs" type="moeda">Base de Cálculo (BC) IBS e CBS</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total do IBS</h4>
        <RowDetalhes data={ totalIbs?.totalIbsUF } className="no-margin-bottom">
          <ColumnDetalhes field="valorDiferimento" type="moeda" width="33%">Diferimento da UF</ColumnDetalhes>
          <ColumnDetalhes field="valorDevolucaoTributos" type="moeda" width="33%">Devolução de Trib. da UF</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsUF" type="moeda" width="33%">IBS da UF</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalIbs?.totalIbsMunicipio } className="no-margin-bottom">
          <ColumnDetalhes field="valorDiferimento" type="moeda" width="33%">Diferimento do Município</ColumnDetalhes>
          <ColumnDetalhes field="valorDevolucaoTributos" type="moeda" width="33%">Devolução de Trib. do Município</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMunicipio" type="moeda" width="33%">IBS do Município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalIbs }>
          <ColumnDetalhes field="valorIbs" type="moeda" width="33%">Total IBS</ColumnDetalhes>
          <ColumnDetalhes field="valorCreditoPresumido" type="moeda" width="33%">Total Crédito Presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCreditoPresumidoCondSusp" type="moeda" width="33%">Total Créd. Pres. em Cond. Suspensiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total da CBS</h4>
        <RowDetalhes data={ totalCbs } className="no-margin-bottom">
          <ColumnDetalhes field="valorDiferimento" type="moeda" width="33%">Diferimento</ColumnDetalhes>
          <ColumnDetalhes field="valorDevolucaoTributos" type="moeda" width="33%">Devolução de Tributos</ColumnDetalhes>
          <ColumnDetalhes field="valorCbs" type="moeda" width="33%">Total da CBS</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalCbs }>
          <ColumnDetalhes field="valorCreditoPresumido" type="moeda" width="33%">Total Crédito Presumido</ColumnDetalhes>
          <ColumnDetalhes field="valorCreditoPresumidoCondSusp" type="moeda" width="67%">Total Créd. Pres. em Cond. Suspensiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total da Monofasia</h4>
        <RowDetalhes data={ totalMonofasia } className="no-margin-bottom">
          <ColumnDetalhes field="valorIbsMono" type="moeda" width="33%">Total IBS Monofásico</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMonoReten" type="moeda" width="33%">IBS Monofásico Sujeito a Retenção</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsMonoRet" type="moeda" width="33%">IBS Monofásico Retido Anteriormente</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalMonofasia }>
          <ColumnDetalhes field="valorCbsMono" type="moeda" width="33%">Total CBS Monofásica</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsMonoReten" type="moeda" width="33%">CBS Monofásica Sujeita a Retenção</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsMonoRet" type="moeda" width="33%">CBS Monofásica Retida Anteriormente</ColumnDetalhes>
        </RowDetalhes>

        <h4>Total do Estorno de Crédito</h4>
        <RowDetalhes data={ totalEstornoCredito }>
          <ColumnDetalhes field="valorIbsEstornado" type="moeda" width="33%">Total IBS Estornado</ColumnDetalhes>
          <ColumnDetalhes field="valorCbsEstornado" type="moeda"  width="67%">Total CBS Estornada</ColumnDetalhes>
        </RowDetalhes>

        <h3>Total da NFe com IBS / CBS / IS</h3>
        <RowDetalhes data={ totalIbsCbs }>
          <ColumnDetalhes field="valorTotalNfe" type="moeda" colSpan={ 4 }>Valor Total da NFe com IBS / CBS / IS</ColumnDetalhes>
        </RowDetalhes>

        { issqn &&
          <>
            <h3>Totais Referentes ao ISSQN</h3>
            <TableDetalhesComLinhas data={ issqn }>
              <tr>
                <ColumnDetalhes field="valorServicos" type="moeda" width="25%">Valor dos Serviços</ColumnDetalhes>
                <ColumnDetalhes field="bcIss" type="moeda" width="25%">BC ISS</ColumnDetalhes>
                <ColumnDetalhes field="iss" type="moeda" width="25%">ISS</ColumnDetalhes>
                <ColumnDetalhes field="pis" type="moeda" width="25%">PIS</ColumnDetalhes>
              </tr>
              <tr>
                <ColumnDetalhes field="cofins" type="moeda">COFINS</ColumnDetalhes>
                <ColumnDetalhes field="dataPrestServico" type="data">Data Prest. Serviço</ColumnDetalhes>
                <ColumnDetalhes field="deducaoReducaoBc" type="moeda">Dedução Redução BC</ColumnDetalhes>
                <ColumnDetalhes field="outrasRetencoes" type="moeda">Outras Retenções</ColumnDetalhes>
              </tr>
              <tr>
                <ColumnDetalhes field="descontoIncod" type="moeda">Desconto Incond.</ColumnDetalhes>
                <ColumnDetalhes field="descontoCond" type="moeda">Desconto Cond.</ColumnDetalhes>
                <ColumnDetalhes field="retencaoIss" type="moeda">Retenção ISS</ColumnDetalhes>
                <ColumnDetalhes field="codRegimeEspTrib" type="moeda">Cód. Regime Esp. Trib.</ColumnDetalhes>
              </tr>
            </TableDetalhesComLinhas>
          </>
        }

        { retencaoTributos &&
          <>
            <h3>Totais Retenção de Tributos</h3>
            <RowDetalhes data={ retencaoTributos } className="no-margin-bottom">
              <ColumnDetalhes field="valorRetidoPis" type="moeda" width="25%">Valor Retido PIS</ColumnDetalhes>
              <ColumnDetalhes field="valorRetidoCofins" type="moeda" width="25%">Valor Retido COFINS</ColumnDetalhes>
              <ColumnDetalhes field="valorRetidoCsll" type="moeda" width="25%">Valor Retido CSLL</ColumnDetalhes>
              <ColumnDetalhes field="bcIrrf" type="moeda" width="25%">BC do IRRF</ColumnDetalhes>
            </RowDetalhes>
            <RowDetalhes data={ retencaoTributos }>
              <ColumnDetalhes field="valorRetidoIrrf" type="moeda" width="25%">Valor Retido IRRF</ColumnDetalhes>
              <ColumnDetalhes field="bcRetencaoPrevSocial" type="moeda" width="25%">BC Retenção Prev.
                Social</ColumnDetalhes>
              <ColumnDetalhes field="valorRetencaoPrevSocial" type="moeda" width="50%">Valor Retenção Prev.
                Social</ColumnDetalhes>
            </RowDetalhes>
          </>
        }
      </div>
  );
}
